import React from 'react';
import { useTranslation } from 'react-i18next';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Outlet } from 'react-router-dom';
import Helmet from 'react-helmet';
import { route } from '../routes';
import usePageTracking from '@careers-wales/react-components/dist/hooks/usePageTracking';

function App(props) {
  const { t } = useTranslation();

  // Page tracking.
  usePageTracking();

  return (
    <>
      <Helmet>
        {/* Adding meta description tag for #11947 */}
        {/* https://dev.azure.com/ccdg/CWO%20-%20SEO/_workitems/edit/11947 */}
        <meta name="description" content={t('app.description')} />
      </Helmet>
      <BreadcrumbsItem to={route('landing')}>{t('app.breadcrumb')}</BreadcrumbsItem>
      <Outlet />
    </>
  );
}

export default App;
